import styles from './index.module.less';

const Block = ({ style }: { style?: React.CSSProperties }) => (
  <div
    style={{
      borderRadius: 12,
      background: 'var(--color-surface-secondary, #f3f4f6)',
      width: '100%',
      ...style,
    }}
    aria-hidden="true"
  />
);

/**
 * Home pending shape, rendered from the route DEF while the home chunk
 * downloads (first visit). Constant chrome — the page's own container/logo/
 * section rhythm from its real CSS module — with grey blocks standing in for
 * the nav cards and stacked sections, so the loaded page swaps only content,
 * never layout. Home is a top-level tab: no back stub. Eager-safe (DEF-file
 * import): the CSS module plus inline-styled blocks only — no hooks, i18n, or
 * lazy-chunk imports.
 */
export function HomeRoutePending() {
  return (
    <div className={styles.container} aria-busy="true">
      <div className={styles.logo}>
        <Block style={{ height: 32, width: 140 }} />
      </div>

      {/* Nav-cards row (horizontal scroll strip on the real page). */}
      <div className={styles.navCards}>
        <Block style={{ height: 96, flex: '0 0 150px' }} />
        <Block style={{ height: 96, flex: '0 0 150px' }} />
        <Block style={{ height: 96, flex: '0 0 150px' }} />
      </div>

      {/* Wish-list alpha card. */}
      <div className={styles.alphaCard}>
        <Block style={{ height: 148 }} />
      </div>

      {/* Data-report card. */}
      <div className={styles.alphaCard}>
        <Block style={{ height: 88 }} />
      </div>

      {/* Happening-soon class grid. */}
      <div className={styles.classGrid}>
        <Block style={{ height: 170 }} />
        <Block style={{ height: 170 }} />
        <Block style={{ height: 170 }} />
      </div>

      {/* Contact-us card. */}
      <div className={styles.alphaCard}>
        <Block style={{ height: 88 }} />
      </div>
    </div>
  );
}
